import React from 'react';
import {UtcTimestampCell} from "../common/advance-table/CustomCells";
import {useFragment} from "react-relay";
import graphql from "babel-plugin-relay/macro";
import {useUser} from "../../hooks/useUser";
import {useTableModals} from "../../hooks/useTableModals";
import AdvanceTableWrapper from "../common/advance-table/AdvanceTableWrapper";
import {Card} from "react-bootstrap";
import CardTableHeader from "../common/headers/CardTableHeader";
import AdvanceTable from "../common/advance-table/AdvanceTable";
import AdvanceTablePagination from "../common/advance-table/AdvanceTablePagination";
import DeleteModal from "../common/modals/DeleteModal";
import NewAttachmentModal from "./NewAttachmentModal";

const defaultColumns = [
    {
        accessor: 'fileName',
        Header: "File Name",
        Cell: rowData => {
            const {downloadUrl, id, fileName} = rowData.row.original;
            return (<a href={downloadUrl} download={fileName}>{fileName}</a>);
        }
    },
    {
        accessor: 'category.name',
        Header: "Category",
    },
    {
        accessor: 'size',
        Header: "Size",
    },
    {
        accessor: 'lastModifiedTimestampUtc',
        Header: "Last Modified",
        Cell: UtcTimestampCell
    }
]

const Attachments = ({attachments, parentId, attachmentCategories, createPermission, deletePermission}) => {
    const data = useFragment(graphql`
        fragment Attachments on Attachment @relay(plural:true) {
            id
            fileName
            size
            lastModifiedTimestampUtc
            downloadUrl
            category {
                id
                name
            }
        }`, attachments);
    const deleteMutation = graphql`
        mutation AttachmentsDeleteMutation($id: ID!) {
            deleteNode(input: {id: $id}) {
                deletedNodeId @deleteRecord
                owner {
                    ... on LegalContract {
                        id
                        attachments {
                            id
                        }}
                    ... on NetworkOwner {
                        id
                        attachments {
                            id
                        }
                    }
                    ... on Network {
                        id
                        attachments {
                            id
                        }
                    }
                    ... on Organization {
                        id
                        attachments {
                            id
                        }
                    }
                }}}`;
    const {hasPermission} = useUser();
    const {selected, columns, newModal, deleteModal} = useTableModals(defaultColumns, "", deletePermission)

    return (
        <>
            <AdvanceTableWrapper columns={columns}
                                 data={data}
                                 sortable
                                 pagination
                                 perPage={10}
                                 initialSortColumn={'fileName'}
            >
                <Card className="mb-3">
                    <Card.Header>
                        <CardTableHeader onNewClick={newModal.onClick}
                                         title={"Attachments"}
                                         table
                                         showNew={hasPermission(createPermission)}
                        />
                    </Card.Header>
                    <Card.Body className="p-0">
                        <AdvanceTable table
                                      headerClassName="bg-200 text-900 text-nowrap align-middle"
                                      rowClassName="align-middle white-space-nowrap"
                                      tableProps={{
                                          size: 'sm',
                                          striped: true,
                                          className: 'fs--1 mb-0 overflow-hidden'}}
                        />
                    </Card.Body>
                    <Card.Footer>
                        <AdvanceTablePagination table/>
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>
            <NewAttachmentModal parentId={parentId}
                                allAttachmentCategories={attachmentCategories}
                                showModal={newModal.showModal}
                                onClose={newModal.onClose}
            />
            {selected && <DeleteModal mutation={deleteMutation}
                                      onClose={deleteModal.onClose}
                                      thingToDelete={"Attachment"}
                                      showModal={deleteModal.showModal}
                                      id={selected.id}>
                <p>This cannot be undone.</p>
            </DeleteModal>}
        </>
    )
}
export default Attachments